module.exports = __webpack_public_path__ + "img/Get paid.5efe517d.svg";